import { Assistant } from "@inrev/assistant";
import { Text } from "@portal/components/primitives";
import { FredTrendChart } from "../../../../../market-analytics/FredTrendChart";

/** Separate cards, because series carry different units and one shared axis would mislead. */
export const AdminAssistantFredChart = ({ chart }: { chart: Assistant.Charts.FredChart }) => (
	<div className="flex flex-col gap-2" data-testid="assistant-fred-chart">
		{chart.title === undefined ? null : (
			<Text type="body-strong" color="primary">
				{chart.title}
			</Text>
		)}
		{[...new Set(chart.seriesCodes)].map((seriesCode) => (
			<FredTrendChart
				key={seriesCode}
				seriesCode={seriesCode}
				from={chart.from}
				to={chart.to}
				variant={chart.variant}
				trailingYears={Assistant.Charts.FRED_CHART_TRAILING_YEARS}
			/>
		))}
	</div>
);
